import React from "react"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { DefaultPageComp } from "../../components/defaultPage"
import { HomeComponent } from "../../components/home"

export const HomePage = () => {
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <HomeComponent />
    </DefaultPageComp>
  </>
}